export default __webpack_public_path__ + "static/media/descargar.e8771466.svg";